import React from 'react'
import Header from '../components/header'
import Hero1 from '../components/hero1'
import Search from '../components/search'
import Chooseus from '../components/chooseus'
import Team from '../components/team'
import Newsletter from '../components/newsletter'
import Footer from '../components/footer'
import About1 from '../components/about'
import { Link } from 'react-router-dom';
function About() {
  return (<div>
      <Header />
      <div class="container-fluid pt-5 bg-primary hero-header">
        <div class="container pt-5">
            <div class="row g-5 pt-5">
                <div class="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
                    <h1 class="display-4 text-white mb-4 animated slideInRight">About Us</h1>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb justify-content-center justify-content-lg-start mb-0">
                        <li class="breadcrumb-item"><Link class="text-white" to="/">Home</Link></li>
                          <li class="breadcrumb-item"><Link class="text-white" to="/">Pages</Link></li>
                            <li class="breadcrumb-item text-white active" aria-current="page">About Us</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-lg-6 align-self-end text-center text-lg-end">
                    <img class="img-fluid hero-about-page" src="img/hero-img.png" alt="" ></img>
                </div>
            </div>
        </div>
    </div>
      <Search />
      <About1 />
      <Chooseus />
      <Team />
      <Newsletter />
      <Footer />
    </div>
  )
}

export default About
